import { render, staticRenderFns } from "./ServeTeamManage.vue?vue&type=template&id=6e9c56da&scoped=true&"
import script from "./ServeTeamManage.vue?vue&type=script&lang=js&"
export * from "./ServeTeamManage.vue?vue&type=script&lang=js&"
import style0 from "./ServeTeamManage.vue?vue&type=style&index=0&id=6e9c56da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c56da",
  null
  
)

export default component.exports